import React, { useState, /* useRef, */ Fragment } from 'react';
import { Row, Col, ButtonToolbar, Button, Card, ProgressBar, Badge, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getProjectsOfAggregate } from '@lib/api';
//import CustomQuickFilterBox from 'components/ag-grid/CustomQuickFilterBox';
import CustomPaginationMui from '@components/materialComponents/CustomPaginationMui';
import { IcoCross, ArrowRight, IcoPaper, IcoPapers, IcoPadlockOpen, IcoPadlockClosed, PersonCircle } from '@icons';
import ProjectAggregateButton from './ProjectAggregatesList/ProjectAggregateButton';
import { dateFormatter, formatToDecimals } from '@lib/helpers/formatting';
import { useHasPermission } from '@lib/hooks/useHasPermission';
import DebouncedSearchInput from '@components/atomic/molecules/DebouncedSearchInput/DebouncedSearchInput';
import ImportExportButtons from './EnteEroganteProjectsList/ImportExportButtons';
import EditModal from './EnteEroganteProjectsList/EditModal';
import EllipsisWithTooltip from '@components/atomic/molecules/EllipsisWithTooltip/EllipsisWithTooltip';

const ProjectsListCards = ({
	projects,
	projectsMeta,
	projectsAggregate,
	projectsAggregateMeta,
	isPendingAggregate,
	isPendingSingle,
	setProjects,
	setProjectsMeta,
	handleShowModal,
	setShowModalProject,
	searchTerm,
	setSearchTerm,
	isGuestEnteErogante,
	permissions,
}) => {
	const hasPermissionAdvancement = useHasPermission(['view-avanzamento-tab']);
	const hasPermissionAdvancementEconomic = useHasPermission(['view-avanzamento-economico-tab']);
	const hasPermissionAdvancementPhysical = useHasPermission(['view-avanzamento-fisico-tab']);
	const [expanded, setExpanded] = useState({});
	const [details, setDetails] = useState({});
	const [loadingDetails, setLoadingDetails] = useState({});
	//console.log('projectsAggregate', projectsAggregate);
	//console.log('details', details);
	//console.log('permissions.canCreateNewProject:', permissions?.canCreateNewProject);
	//console.log('isGuestEnteErogante', isGuestEnteErogante);

	const handleToggleExpand = async (id) => {
		setExpanded((prev) => ({
			...prev,
			[id]: !prev[id],
		}));

		// Se stai espandendo e non hai ancora i dati, fai la fetch
		if (!expanded[id] && !details[id]) {
			setLoadingDetails((prev) => ({ ...prev, [id]: true }));
			try {
				const resp = await getProjectsOfAggregate(id);
				setDetails((prev) => ({ ...prev, [id]: resp.data }));
			} catch (e) {
				// gestisci errore se vuoi
			} finally {
				setLoadingDetails((prev) => ({ ...prev, [id]: false }));
			}
		}
	};

	const progressBarValue = (type, project) => {
		//const containerRef = useRef(null);
		let result = 0;

		if (type === 'final-balance') {
			result =
				project.totalFinalAmount !== null && project.totalAmount !== null ? (project.totalFinalAmount / project.totalAmount) * 100 : 0;
		}

		result = isFinite(result) && result > 0 ? result : 0;

		const progressValue = formatToDecimals(result, 0, 0);

		return progressValue;
	};

	const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

	return (
		<>
			<div className="mt-5 mb-4">
				<span style={{ fontWeight: '700', fontSize: '28px' }}>Lista dei progetti</span>
				<span className="d-block" style={{ fontWeight: '400', fontSize: '18px', lineHeight: '28px', marginTop: '1rem' }}>
					Qui troverai la lista di tutti i tuoi progetti.
				</span>
			</div>

			<div
				className="row d-flex align-items-center"
				style={{
					marginBottom: '3rem',
					marginTop: isGuestEnteErogante ? 0 : '-7rem',
				}}
			>
				<div className="col-6">{isGuestEnteErogante && <ImportExportButtons />}</div>
				<div className="col-6 text-right pt-4 pb-4">
					<ButtonToolbar className="justify-content-end">
						<ProjectAggregateButton />

						{permissions.canCreateNewProject &&
							(isGuestEnteErogante ? (
								<EditModal
									type="create"
									trigger={
										<Button
											className="btn custom-primary-button d-flex justify-content-center align-items-center gap-2"
											style={{
												width: '226px',
												height: '48px',
												fontWeight: 500,
											}}
										>
											<IcoCross className="ico-path-fill-white" style={{ verticalAlign: 'text-top' }} /> Nuovo Progetto
										</Button>
									}
									permissions={permissions}
								/>
							) : (
								<Button
									className="btn custom-primary-button d-flex justify-content-center align-items-center gap-2"
									style={{
										width: '226px',
										height: '48px',
										fontWeight: 500,
									}}
									onClick={() => handleShowModal(setShowModalProject)}
								>
									<IcoCross className="ico-path-fill-white" style={{ verticalAlign: 'text-top' }} /> Nuovo Progetto
								</Button>
							))}
					</ButtonToolbar>
				</div>
			</div>

			<Card className="new-projects-list px-0 custom-ghost-card">
				<Card.Body>
					<div
						className="row mb-1 align-items-center"
						style={{
							backgroundColor: '#fff',
							borderRadius: '12px',
						}}
					>
						<div className="col-8 ps-5">{/* *Filtri avanzati | Resetta filtri* */}</div>
						<div className="col-4 pe-5 pt-3 pb-4 justify-items-end">
							{/* <CustomQuickFilterBox
								tableRef={cardsTableRef}
								dataMeta={projectsMeta}
								setData={setProjects}
								setDataMeta={setProjectsMeta}
								dataLength={projects?.length}
								isFirstResearch={isFirstResearch}
								setIsFirstResearch={setIsFirstResearch}
								refTable="projects"
								isQuickFilterDisabled={true}
							/> */}
							<DebouncedSearchInput
								onSearchTermChange={(term) => {
									setSearchTerm(term);
								}}
								width="auto"
							/>
						</div>
					</div>

					<div
					// style={{ backgroundColor: '#E3E7EB' }}
					>
						{/* PROGETTI AGGREGATI */}
						<div className="p-4 pb-2">
							<div className="d-flex align-items-center gap-2">
								<IcoPapers />
								<span className="section-projects">Progetti raggruppati</span>
								<hr className="hr-new-line flex-grow-1" />
							</div>

							{isPendingAggregate ? (
								<Spinner animation="border" role="status" variant="dark" size="sm" />
							) : projectsAggregate && Array.isArray(projectsAggregate) && projectsAggregate.length > 0 ? (
								projectsAggregate.map((projectAggregate) => (
									<Fragment key={projectAggregate.id}>
										<Row className="px-3 py-12px">
											<Col className="project-aggr-card px-0" style={{ backgroundColor: '#fff', borderRadius: '12px', width: '100%' }}>
												<Button
													as={Link}
													to={`/projects/aggregate-detail/${projectAggregate.id}`}
													className="project-aggr-link btn custom-ghost-button d-block text-decoration-none"
													style={{
														border: 'none',
														boxShadow: 'none',
														textTransform: 'none',
													}}
												>
													<Row className="first-two-rows py-3 ps-4 w-100">
														<Col className="ps-0 pe-3">
															<Row className="flex-nowrap align-items-center">
																<Col className="test title-label text-start d-flex align-items-center gap-2">
																	<EllipsisWithTooltip
																		text={projectAggregate.name}
																		className="two-line-ellipsis"
																		style={{ width: 'fit-content' }}
																	/>
																	<Badge
																		pill
																		bg="info"
																		className="d-flex justify-content-center align-items-center"
																		style={{ minWidth: '100px', maxWidth: '200px', height: '24px', marginTop: '5px' }}
																	>
																		<span className="badge-text" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
																			{projectAggregate.isPublic ? (
																				<>
																					Pubblico
																					<IcoPadlockOpen
																						className="ico-path-fill-white ms-1"
																						height={12}
																						style={{ verticalAlign: 'middle' }}
																					/>
																				</>
																			) : (
																				<>
																					Privato
																					<IcoPadlockClosed
																						className="ico-path-fill-white ms-1"
																						height={12}
																						style={{ verticalAlign: 'middle' }}
																					/>
																				</>
																			)}
																		</span>
																	</Badge>
																</Col>
															</Row>
															<Row className="align-items-center mt-1">
																<Col className="col-auto title-label">Costo totale:</Col>
																<Col className="col-auto p-0">
																	<span className="amount-label" style={{ wordBreak: 'break-all' }}>
																		{formatToDecimals(projectAggregate.projectsSumTotalAmount)} €
																	</span>
																</Col>
															</Row>
														</Col>

														<Col className="col-auto p-0 align-self-center">
															<div
																className="p-0"
																style={{
																	// color: '#06797F',
																	color: 'var(--np-primary-color)',
																	display: 'flex',
																	alignItems: 'center',
																	gap: '0.5rem',
																	fontWeight: '500',
																}}
															>
																apri gruppo
																<ArrowRight />
															</div>
														</Col>
													</Row>
												</Button>

												<Row className="second-two-rows" style={{ padding: '0 0.75rem' }}>
													<Col
														className="py-3"
														style={{ borderTop: '1px solid #C7CFD7', paddingLeft: '1.7rem' }}
														onClick={() => handleToggleExpand(projectAggregate.id)}
													>
														<div className="title-link new-text-as-link" style={{ cursor: 'pointer' }}>
															{expanded[projectAggregate.id] ? 'nascondi' : 'mostra'} progetti
															<span className={`svg-arrow${expanded[projectAggregate.id] ? ' rotated' : ''}`}></span>
														</div>
													</Col>
												</Row>
											</Col>
										</Row>
										{expanded[projectAggregate.id] && (
											<Row className="px-3">
												<Col className="col-auto position-relative">
													{!loadingDetails[projectAggregate.id] && details[projectAggregate.id].length > 0 ? (
														<div className={details[projectAggregate.id].length === 1 ? 'timeline-dot' : 'timeline-line'}></div>
													) : null}
												</Col>
												<Col className="p-0 ps-1">
													{loadingDetails[projectAggregate.id] ? (
														<Spinner animation="border" size="sm" />
													) : details[projectAggregate.id] && details[projectAggregate.id].length > 0 ? (
														details[projectAggregate.id].map((projAggregate) => (
															<Row
																key={'projs-aggregate' + projAggregate.id}
																className="sub-project-aggr-card mx-0 my-3 p-3"
																style={{ backgroundColor: '#fff', borderRadius: '12px' }}
															>
																<Col style={{ flexGrow: 2, maxWidth: '50%' }}>
																	<EllipsisWithTooltip text={projAggregate.name} className="one-line-ellipsis" />
																	{/* <div className="text-label float-start">CUP/ID Progetto&nbsp;</div>
																	<EllipsisWithTooltip text={projAggregate.cup} className="text-label one-line-ellipsis" /> */}
																	<div
																		className="text-label mt-1"
																		style={{
																			display: 'flex',
																			alignItems: 'center',
																			gap: '.5rem',
																		}}
																	>
																		<span
																			style={{
																				whiteSpace: 'nowrap',
																			}}
																		>
																			CUP/ID Progetto
																		</span>

																		<EllipsisWithTooltip text={projAggregate.cup} className="one-line-ellipsis" />

																		{projAggregate.hasAssignedInvoices ? (
																			<Badge
																				bg="secondary"
																				pill
																				style={{
																					display: 'flex',
																					alignItems: 'center',
																					width: 'fit-content',
																					gap: '0.5rem',

																					minWidth: '180px',
																					height: '24px',
																				}}
																			>
																				<PersonCircle
																					style={{
																						width: '1rem',
																						height: '1rem',
																						fill: 'var(--np-text-primary-color)',
																					}}
																				/>
																				Controlli assegnati a te
																			</Badge>
																		) : null}
																	</div>
																</Col>
																<Col>
																	<div className="title-label">Costo</div>
																	<div className="text-label">
																		<EllipsisWithTooltip
																			text={formatToDecimals(projAggregate.totalAmount) + ' €'}
																			className="one-line-ellipsis"
																		/>
																	</div>
																</Col>
																<Col>
																	<div className="title-label">Bando</div>
																	<div className="text-label">
																		<EllipsisWithTooltip text={projAggregate.notice?.call} className="one-line-ellipsis" />
																	</div>
																</Col>
																<Col>
																	<div className="title-label">Beneficiario</div>
																	<div className="text-label">
																		<EllipsisWithTooltip text={projAggregate.company?.name} className="one-line-ellipsis" />
																	</div>
																</Col>
																<Col>
																	<div className="title-label">Avvio</div>
																	<div className="text-label">
																		{projAggregate.startDate ? dateFormatter(projAggregate.startDate, 'DD/MM/YYYY') : '-'}
																	</div>
																</Col>
																<Col className="col-auto p-0 align-self-center">
																	<Button
																		as={Link}
																		to={`/project/${projAggregate.id}/dashboard`}
																		className="btn custom-ghost-button p-0 pe-3"
																		style={{
																			textTransform: 'none',
																			// color: '#06797F',
																			color: 'var(--np-primary-color)',
																			display: 'flex',
																			alignItems: 'center',
																			gap: '0.5rem',
																			fontWeight: '500',
																		}}
																	>
																		apri
																		<ArrowRight />
																	</Button>
																</Col>
															</Row>
														))
													) : (
														<div>Nessun progetto disponibile</div>
													)}
												</Col>
											</Row>
										)}
									</Fragment>
								))
							) : (
								<div className="mt-3">non ci sono progetti aggregati</div>
							)}
						</div>

						{/* PROGETTI SINGOLI */}
						<div className="p-4">
							<div className="d-flex align-items-center gap-2">
								<IcoPaper />
								<span className="section-projects">Progetti singoli</span>
								<hr className="hr-new-line flex-grow-1" />
							</div>

							{isPendingSingle ? (
								<Spinner animation="border" role="status" variant="dark" size="sm" />
							) : projects && Array.isArray(projects) && projects.length > 0 ? (
								projects.map((project) => (
									<Row key={project.id} className="project-card px-3 py-12px">
										<Col
											className="first-two-columns col-9 px-0"
											style={{ backgroundColor: '#fff', borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px', zIndex: 10 }}
										>
											<Button
												as={Link}
												variant="link"
												to={`/project/${project.id}/dashboard`}
												className="project-card-link w-100 h-100 p-0 d-block text-decoration-none"
											>
												<Row className="py-0 ps-1 pe-2 justify-content-between flex-nowrap">
													<Col style={{ marginLeft: '-1px', marginRight: '2px' }}>
														<Row style={{ padding: '0.7rem 0 0.7rem 1rem' }}>
															<Col className="col-8" style={{ maxWidth: '70%' }}>
																<EllipsisWithTooltip text={project.name} className="title-label two-line-ellipsis" />
																<div
																	className="text-label mt-1"
																	style={{
																		display: 'flex',
																		alignItems: 'center',
																		gap: '.5rem',
																	}}
																>
																	<span
																		style={{
																			whiteSpace: 'nowrap',
																		}}
																	>
																		CUP/ID Progetto
																	</span>

																	<EllipsisWithTooltip text={project.cup} className="one-line-ellipsis" />

																	{project.hasAssignedInvoices ? (
																		<Badge
																			bg="secondary"
																			pill
																			style={{
																				display: 'flex',
																				alignItems: 'center',
																				width: 'fit-content',
																				gap: '0.5rem',

																				minWidth: '180px',
																				height: '24px',
																			}}
																		>
																			<PersonCircle
																				style={{
																					width: '1rem',
																					height: '1rem',
																					fill: 'var(--np-text-primary-color)',
																				}}
																			/>
																			Controlli assegnati a te
																		</Badge>
																	) : null}
																</div>
															</Col>
															<Col className="col-4">
																<div className="title-label">Costo</div>
																<div className="amount-label">{formatToDecimals(project.totalAmount)} €</div>
															</Col>
														</Row>
														<Row className="second-row py-3 ps-3">
															<Col>
																<div className="title-label">Bando</div>
																<EllipsisWithTooltip text={project.notice?.call} className="text-label one-line-ellipsis" />
															</Col>
															<Col>
																<div className="title-label">Beneficiario</div>
																<EllipsisWithTooltip text={project.company?.name} className="text-label one-line-ellipsis" />
															</Col>
															<Col>
																<div className="title-label">Avvio</div>
																<div className="text-label">{dateFormatter(project.startDate, 'DD/MM/YYYY')}</div>
															</Col>
														</Row>
													</Col>
												</Row>
											</Button>
										</Col>

										<Col
											className="second-two-columns col-auto px-0"
											style={{
												borderLeft: '1px solid #C7CFD7',
												borderTopRightRadius: '12px',
												borderBottomRightRadius: '12px',
												backgroundColor: '#fff',
												zIndex: 1,
											}}
										>
											<Button
												as={Link}
												variant="link"
												to={`/project/${project.id}/dashboard`}
												className="w-100 h-100 px-2 d-block text-decoration-none"
											>
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														height: '100%',
														justifyContent: 'center',
														paddingLeft: '0.5rem',
														paddingRight: '1rem',
													}}
												>
													<ArrowRight className="ico-path-fill-primary" />
												</div>
											</Button>
										</Col>

										<Col
											className="pe-0"
											style={{
												// backgroundColor: '#C7CFD7',
												backgroundColor: '#fff',
												borderRadius: '12px',
												marginLeft: '-3rem',
											}}
										>
											<ConditionalWrapper
												condition={hasPermissionAdvancement}
												wrapper={(children) => (
													<Button
														as={Link}
														variant="link"
														className="add-on-link text-decoration-none h-100"
														style={{
															// color: '#1C2743',
															textTransform: 'none',
															lineHeight: '24px',
															width: '-webkit-fill-available',
															paddingLeft: '3.6rem',
														}}
														to={`/project/${project.id}/execution/${hasPermissionAdvancementEconomic ? 'economic' : hasPermissionAdvancementPhysical ? 'physical' : ''}`}
													>
														{children}
													</Button>
												)}
											>
												<Row className={`flex-column h-100 text-start pe-3 ${hasPermissionAdvancement ? '' : 'ms-5'}`}>
													<Col className="align-content-end pe-3">
														<Row className="row-add-on">
															<span
																className={`title-add-on w-auto fs-16 f-700 lh-24 ${hasPermissionAdvancement ? 'text-decoration-underline' : ''}`}
															>
																Avanzamento spesa
															</span>
															<ArrowRight className="d-none w-auto p-0 ico-path-fill-dark-green" />
														</Row>

														<Row className="align-items-center flex-row mt-1">
															<Col className="pe-0">
																<ProgressBar
																	className="green-bar p-0"
																	now={progressBarValue('final-balance', project)}
																	min={0}
																	max={100}
																	style={{ borderRadius: '8px' }}
																/>
															</Col>

															<Col className="col-auto m-0">
																<span
																	style={{ fontSize: '16px', fontWeight: '700', lineHeight: '24px', color: 'var(--np-text-primary-color)' }}
																>
																	{progressBarValue('final-balance', project)}%
																</span>
															</Col>
														</Row>
													</Col>

													<Col
														className="pe-3 pt-3 f-400 fs-14"
														style={{
															color: 'var(--np-text-primary-color)',
														}}
													>
														Spesa effettuata sul budget totale previsto.
													</Col>
												</Row>
											</ConditionalWrapper>
										</Col>
									</Row>
								))
							) : (
								<div className="mt-3">non ci sono progetti singoli</div>
							)}
						</div>
					</div>

					<div
						style={{
							backgroundColor: '#fff',
							borderRadius: '12px',
							padding: '10px 18px',
						}}
					>
						{Object.keys(projectsMeta).length > 0 && (
							<CustomPaginationMui
								dataMeta={projectsMeta}
								setData={setProjects}
								setDataMeta={setProjectsMeta}
								rowsPerPageOptions={[5, 10, 100, 200, 500]}
								refTable="projectscards"
								setIsFirstResearch={() => {}}
								rowsPerPageDefault={5}
								labelRowsPerPage={'progetti singoli per pagina:'}
							/>
						)}
					</div>
				</Card.Body>
			</Card>
		</>
	);
};

export default ProjectsListCards;
